import { createLightbox } from './nexus-interfaces/lightbox';
import { trackEvent } from '@otto-ec/nexus-registry/pdp/tracking';

export class CustomerReviewLightbox {
    public static async init(
        rootElement: HTMLElement,
        gallerySelector: string,
        imageSelector: string,
        position: 'top' | 'bottom'
    ): Promise<void> {
        let isFirstChange = true;
        const imagesElement = rootElement.querySelector<HTMLElement>(gallerySelector);
        if (!imagesElement) return;
        await createLightbox({
            gallery: imagesElement,
            children: imageSelector,
            thumbSelector: 'img',
            onOpen: (index, numItems) => {
                const imageElements = imagesElement.querySelectorAll<HTMLElement>(imageSelector);
                const rating = imageElements[index]?.dataset.rating ?? rootElement.dataset.rating ?? '0';

                trackEvent({
                    product_ReviewImageView: [position],
                    product_ReviewImageGallery: [position === 'top' ? 'full_gallery' : 'single_review'],
                    product_ValenceOfOpenedReviewImage: [rating],
                    product_DifferentReviewImageChange: [`${index + 1}|${numItems}`],
                });
            },
            onChange: (index, numItems) => {
                trackEvent({
                    product_ReviewImageView: [isFirstChange ? 'change_first' : 'change_following'],
                    product_ReviewImageGallery: [position === 'top' ? 'full_gallery' : 'single_review'],
                    product_DifferentReviewImageChange: [`${index + 1}|${numItems}`],
                });
                isFirstChange = false;
            },
            onClose: () => {
                isFirstChange = true;
            },
        });
    }
}
